import { createContext, useContext } from 'react';
import { IBaseModel, IListFetchParams } from './commonInterfaces';
import { UseListReturn } from './useList';
import { MODULE } from './commonTypes';
import { BaseRepository } from './commonClasses';

export interface ListContextType<
  T extends IBaseModel,
  Q extends IListFetchParams,
> extends UseListReturn<T, Q> {
  setFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  moduleName: MODULE;
  repository: BaseRepository<T, Q>;
  updateStore?: boolean;
  goToPage?: (page: number) => void;
}

export const ListContext = createContext<ListContextType<any, any> | undefined>(
  undefined,
);

export const useListContext = <
  T extends IBaseModel,
  Q extends IListFetchParams,
>() => {
  const context = useContext(ListContext) as ListContextType<T, Q> | undefined;
  if (context === undefined) {
    throw new Error('useListContext must be used within a ListProvider');
  }
  return context;
};
